import React, { PureComponent } from 'react';
import { addTranslation, IntlProps } from 'decorators/addTranslation';
import Button from 'components/ui/button';
import './balanceFilters.scss';
import { generateExcel } from 'pages/finance/balance/generateExcel';
import { BalanceGroup } from 'pages/finance/balance/components/filters/types';
import { connect } from 'react-redux';

interface ConnectedProps {
  balances: BalanceGroup[],
  isDownloadRealTimeBalancesEnabled: boolean
}

interface Props extends IntlProps, ConnectedProps {}

class BalanceFilters extends PureComponent<Props, any> {
  render() {
    const { isDownloadRealTimeBalancesEnabled } = this.props;

    return (
      <div className="balance-filters">
        {isDownloadRealTimeBalancesEnabled && <Button
          status="light"
          icon="im-Download1"
          customClass="ui-button_no-border"
          onClick={this.onDownloadExcel}
        />}
      </div>
    );
  }

  onDownloadExcel = () => {
    const { balances } = this.props;
    generateExcel(balances);
  };
}

const mapStateToProps = (state): ConnectedProps => {
  const { data: { balances: { items } }, user: { isDownloadRealTimeBalancesEnabled } } = state;

  return {
    balances: items,
    isDownloadRealTimeBalancesEnabled
  };
};

export default connect(mapStateToProps)(addTranslation(BalanceFilters));
